import { useSettings } from "@/context/SettingsContext";
import { useCurrency } from "@/context/CurrencyContext";

/**
 * Dynamic top-of-page banners.
 * - Ireland banner: only when `free_shipping_ireland` OR `free_shipping_global` is ON.
 * - UK banner: only when `free_shipping_uk` OR `free_shipping_global` is ON.
 * Both can display together (stacked, one per line). Auto-hide when toggled off.
 * Legacy `free_shipping_enabled` also treated as global.
 */
export default function AnnouncementBar() {
  const { settings } = useSettings();
  const { currency } = useCurrency();
  if (!settings) return null;

  const global = Boolean(settings.free_shipping_global || settings.free_shipping_enabled);
  const showIreland = Boolean(global || settings.free_shipping_ireland);
  const showUK = Boolean(global || settings.free_shipping_uk);

  if (!showIreland && !showUK) return null;

  // If a customer's currency exactly matches one region, prioritise showing that one first.
  const banners = [];
  if (showIreland) {
    banners.push({ key: "ie", flag: "🇮🇪", text: "Free Shipping to Ireland!", first: currency === "EUR" });
  }
  if (showUK) {
    banners.push({ key: "uk", flag: "🇬🇧", text: "Free Shipping to UK!", first: currency === "GBP" });
  }
  banners.sort((a, b) => (b.first ? 1 : 0) - (a.first ? 1 : 0));

  return (
    <div className="w-full relative z-40" data-testid="announcement-bar">
      {banners.map((b) => (
        <div
          key={b.key}
          className="w-full bg-[#D4AF37] text-black text-xs md:text-sm font-semibold uppercase tracking-[0.2em] py-2 px-4 flex items-center justify-center gap-2 border-b border-black/10"
          data-testid={`free-shipping-announcement-${b.key}`}
        >
          <span aria-hidden className="text-base leading-none">{b.flag}</span>
          <span>{b.text}</span>
        </div>
      ))}
    </div>
  );
}
